import { KeyValue } from '@/main/models/common';
import { VehicleYearRequest } from '@/main/models/request';
import { IInitialReducerData } from '@/main/services/reducerUtils';

export enum YearTypes {
  GET_YEARS = '@year/GET_YEARS',
  GET_YEARS_BY_MANUFACTURER_AND_MODEL = '@year/GET_YEARS_BY_MANUFACTURER_AND_MODEL',
  SAVE_YEARS = '@year/SAVE_YEARS',
  RESET_REDUCER_YEARS = '@year/RESET_REDUCER_YEARS'
}

export interface YearState {
  readonly years: {
    data: KeyValue[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
  readonly isolated: {
    [key: string]: IInitialReducerData;
  };
}

export interface GetYears {
  type: typeof YearTypes.GET_YEARS;
  payload: {
    keyReducer: string;
  };
}
export interface GetYearByManufacturerAndModel {
  type: typeof YearTypes.GET_YEARS_BY_MANUFACTURER_AND_MODEL;
  payload: {
    request: VehicleYearRequest;
    keyReducer: string;
  };
}

export interface SaveYears {
  type: typeof YearTypes.SAVE_YEARS;
  payload: {
    data: KeyValue[] | null;
    isError: boolean;
    errorMessages: string[] | null;
    keyReducer: string;
  };
}

export interface ResetReducerYears {
  type: typeof YearTypes.RESET_REDUCER_YEARS;
  payload: {
    keyReducer: string;
  };
}

export type YearActionTypes =
  | GetYears
  | GetYearByManufacturerAndModel
  | SaveYears
  | ResetReducerYears;

